import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from './hooks/useAuth';
import { BrandSettingsProvider } from './contexts/BrandSettingsContext';
import ProtectedRoute from './components/ProtectedRoute';

// Pages
import LandingPage from './pages/LandingPage';
import PricingPage from './pages/PricingPage';
import SignupFlowPage from './pages/SignupFlowPage';
import DynamicPage from './pages/DynamicPage';
import FeaturesPage from './pages/FeaturesPage';
import StandardsPage from './pages/StandardsPage';
import ResourcesPage from './pages/ResourcesPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import DemoPage from './pages/DemoPage';
import InsightsPage from './pages/InsightsPage';
import InsightPostPage from './pages/InsightPostPage';

// CMS Pages
import CMSLoginPage from './pages/CMSLoginPage';
import CMSDashboard from './cms/CMSDashboard';
import PageBuilder from './cms/PageBuilder';
import CMSPagesPage from './pages/CMSPagesPage';
import CMSBlogPage from './pages/CMSBlogPage';
import CMSMediaPage from './pages/CMSMediaPage';
import CMSSettingsPage from './pages/CMSSettingsPage';
import CMSSystemPages from './pages/CMSSystemPages';

function App() {
  return (
    <Router>
      <AuthProvider>
        <BrandSettingsProvider>
          <Toaster position="top-right" richColors />
          
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/features" element={<FeaturesPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/standards" element={<StandardsPage />} />
            <Route path="/resources" element={<ResourcesPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/demo" element={<DemoPage />} />
            <Route path="/insights" element={<InsightsPage />} />
            <Route path="/insights/:slug" element={<InsightPostPage />} />
            <Route path="/signup" element={<SignupFlowPage />} />
            
            {/* CMS Login */}
            <Route path="/cms/login" element={<CMSLoginPage />} />
            
            {/* CMS Routes - Protected */}
            <Route path="/cms" element={
              <ProtectedRoute allowedRoles={['admin', 'super_admin']}>
                <CMSDashboard />
              </ProtectedRoute>
            } />
            <Route path="/cms/pages" element={
              <ProtectedRoute allowedRoles={['admin', 'super_admin']}>
                <CMSPagesPage />
              </ProtectedRoute>
            } />
            <Route path="/cms/pages/new" element={
              <ProtectedRoute allowedRoles={['admin', 'super_admin']}>
                <PageBuilder />
              </ProtectedRoute>
            } />
            <Route path="/cms/pages/:pageId" element={
              <ProtectedRoute allowedRoles={['admin', 'super_admin']}>
                <PageBuilder />
              </ProtectedRoute>
            } />
            <Route path="/cms/blog" element={
              <ProtectedRoute allowedRoles={['admin', 'super_admin']}>
                <CMSBlogPage />
              </ProtectedRoute>
            } />
            <Route path="/cms/media" element={
              <ProtectedRoute allowedRoles={['admin', 'super_admin']}>
                <CMSMediaPage />
              </ProtectedRoute>
            } />
            <Route path="/cms/settings" element={
              <ProtectedRoute allowedRoles={['admin', 'super_admin']}>
                <CMSSettingsPage />
              </ProtectedRoute>
            } />
            <Route path="/cms/system-pages" element={
              <ProtectedRoute allowedRoles={['admin', 'super_admin']}>
                <CMSSystemPages />
              </ProtectedRoute>
            } />
            
            {/* Dynamic CMS Pages - Catch-all for CMS-managed pages */}
            <Route path="/:slug" element={<DynamicPage />} />
          </Routes>
        </BrandSettingsProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
